export const EXTERNAL_LINKS = Object.freeze({
  mainSite: "https://caylet.com",
  esim: "https://esim.caylet.com",
  ipRoyal: "https://caylet.com/iproyal",
  privacy: "https://caylet.com/privacy-policy/",
  terms: "https://caylet.com/terms-of-use/",
  scamalytics: "https://scamalytics.com"
});
